import React from 'react';
import { Box, Grid, CircularProgress, Typography } from '@material-ui/core';
import InfiniteScroll from 'react-infinite-scroll-component';

import CarCard from 'components/elements/organisms/CarCard';
import useCars from '../../context/useCars';
import { useIsDesktop, useTranslations } from 'components/utilities';

const CarList = () => {
	const { t } = useTranslations();
	const { items, hasMore, loading, fetchMore } = useCars();

	const isDesktop = useIsDesktop();

	return (
		<Box>
			<InfiniteScroll
				dataLength={items.length}
				next={fetchMore}
				hasMore={hasMore}
				style={{ overflow: 'initial' }}
				scrollableTarget={window}
			>
				<Grid container spacing={isDesktop ? 5 : 2}>
					{items.map((car) => (
						<Grid item xs={12} md={6} key={car.id}>
							<CarCard car={car} />
						</Grid>
					))}
				</Grid>
			</InfiniteScroll>
			{loading && (
				<Box p={5} display="flex" justifyContent="center">
					<CircularProgress />
				</Box>
			)}
			{!loading && !items.length > 0 && (
				<Box p={5}>
					<Typography align="center" variant="h5">
						{t('cars.noCars')}
					</Typography>
				</Box>
			)}
			{!loading && isDesktop && items.length > 0 && !hasMore && (
				<Box p={5}>
					<Typography align="center" variant="h5">
						{t('cars.noMoreCars')}
					</Typography>
				</Box>
			)}
		</Box>
	);
};

export default CarList;
